import React from "react";
import {Flex} from "reflexbox";
import * as type from "./questionTypes"
import {tippingMidway, teamNameInput} from './questionContentUniversal'

//location images reflecting pool
import lincolnImage from '../../images/reflectingPool/locations/lincoln.jpg'
import washingtonImage from '../../images/reflectingPool/locations/wash-monumnet.jpg'
import koreaImage from '../../images/reflectingPool/locations/korean_war_mem.jpg'
import gardensImage from '../../images/reflectingPool/locations/constitutionGardens.jpg'
import vietnamImage from '../../images/reflectingPool/locations/vietnam.jpg'
import wwIIimage from '../../images/reflectingPool/locations/wwII.jpg'

//question images
//lincoln question pics
import aslPoster from "../../images/reflectingPool/questions/ASL-poster.jpg"
import AL_Image from "../../images/reflectingPool/questions/AL.jpg"
import commonColumnTypes from "../../images/reflectingPool/questions/Common-Column-Types.png"
import lincolnTypo from "../../images/reflectingPool/questions/Euture.jpg"
import cavernBeneath from "../../images/reflectingPool/questions/cavernBeneathLincoln.jpg"
import lionAndEagle from "../../images/reflectingPool/questions/lionAndEagle.jpg"
import LincolnColumns from "../../images/reflectingPool/questions/LincolnColumns.jpg"
import underneathLincoln from "../../images/reflectingPool/questions/underneathLincoln.jpg"
import RomanNumerals from "../../images/reflectingPool/questions/Roman-Numerals.png"
import ArkansasMichigan from "../../images/reflectingPool/questions/Arkansas-Michigan.jpg"
import Fido from "../../images/reflectingPool/questions/Fido.jpg"
import mlkAtMarch from "../../images/reflectingPool/questions/MLK-at-march.jpg"
import mlkEngraving from "../../images/reflectingPool/questions/MLK-engraving.jpg"
//korean question pics
import koreanPeninsula from "../../images/reflectingPool/questions/Korea.JPG"
import koreanMemorialTriangle from "../../images/reflectingPool/questions/Korean-Memorial-Triangle.png"
import powMiaFlag from "../../images/reflectingPool/questions/pow-mia-flag.png"
import findThisFlag from "../../images/reflectingPool/questions/FindThis.png"
import unitedNationsFlag from "../../images/reflectingPool/questions/Flag_of_the_United_Nations.png"
import unDeployments from "../../images/reflectingPool/questions/UN-Current-and-Past-Missions.png"
import {koreanWarSoldierMapping} from "./funFactTables/koreanWarSoliderMapping";
//vietnam question pics
import star from "../../images/reflectingPool/questions/Star.png"
import womenInVietnam from "../../images/reflectingPool/questions/women-in-vietnam.jpg"
import vietnamHat from "../../images/reflectingPool/questions/vietnamHat.jpg"
import SoliderSleepingInRain from "../../images/reflectingPool/questions/SoldierSleepingInRain.jpg"
import anchorSolution from "../../images/reflectingPool/questions/anchorSolution.jpg" //anchorSolution
import womenStatueVietnam from "../../images/reflectingPool/questions/womenStatueVietnam.jpg"
//constitution gardens question pics
import declarationOfIndependence from "../../images/reflectingPool/questions/declarationOfIndependence.jpg"
import declarationOfIndependenceSigning
  from "../../images/reflectingPool/questions/declarationOfIndependenceSigning.jpg"
import tjStone from "../../images/reflectingPool/questions/tjStone.jpg"
import hancockStone from "../../images/reflectingPool/questions/hancockStone.jpg"
//wwII question pics
import kilroyImage from "../../images/reflectingPool/questions/Kilroy.png"
import kilroyLocation from "../../images/reflectingPool/questions/kilroyLocation.jpg"
import ladyLibertySeal from "../../images/reflectingPool/questions/ladyLibertySeal.jpg"
import goldStar from "../../images/reflectingPool/questions/goldStar.jpg"
import ladyShouting from "../../images/reflectingPool/questions/ladyShouting.jpg"
import coupleKissing from "../../images/reflectingPool/questions/coupleKissing.jpg"
import pearlHarborAttack from "../../images/reflectingPool/questions/pearlHarborAttack.jpg"
import pearlHarborNews from "../../images/reflectingPool/questions/pearlHarborNews.jpg"
import priceOfFreedom from "../../images/reflectingPool/questions/priceOfFreedom.jpg"
import virginiaPillar from "../../images/reflectingPool/questions/virginiaPillar.jpg"
import victoryMedal from "../../images/reflectingPool/questions/victoryMedal.jpg"
//wash mon question pics
import sundialMap from "../../images/reflectingPool/questions/Sundial.jpg"
import jeffersonPier from "../../images/reflectingPool/questions/jeffersonPier.jpg"
import wasMonumentShadesBreakdown from "../../images/reflectingPool/questions/wasMonumentShadesBreakdown.jpg"
import primeMeridian from "../../images/reflectingPool/questions/PrimeMeridian.png"
import WashMonUnderContsruction from "../../images/reflectingPool/questions/WashMonUnderContsruction.png"
import OriginalDesignWashMon from "../../images/reflectingPool/questions/OriginalDesignWashMon.jpg"
//other
import DCMapOverlap from "./DCMapOverlap";
import {personnelTable} from "./funFactTables/vietnamSoldierQuantityByBranch";
import WW2DeathsTable from "./funFactTables/ww2Deaths";


const lincoln = {
  name: 'Lincoln Memorial',
  img: lincolnImage,
};
const korea = {
  name: 'Korean War Memorial',
  img: koreaImage,
};
const vietnam = {
  name: 'Vietnam War Memorial',
  img: vietnamImage,
};
const gardens = {
  name: 'Constitution Gardens',
  img: gardensImage,
};
const wwII = {
  name: 'World War II Memorial',
  img: wwIIimage,
};
const washMon = {
  name: 'Washington Monument',
  img: washingtonImage,
};

// note on regex: make sure to use lowercase as in the question check, we are converting to lowercase
const getToLincoln = {
  location: lincoln,
  type: type.newLocation,
  image1: null,
  content1: 'It won\'t cost money to get into this place, but a $5 bill could help you find it!',
  captionContent: "Tap 'I'm here' when you are at the steps leading up to this place",
  //hint: 'Just think about it',
  answer: {
    image1: lincoln.img,
    content1: 'You made it! The Lincoln memorial is depicted on both the $5 bill and the penny.'
  },

};
const animalsAtLincoln = {
  displayName: "Animals at lincoln",
  location: lincoln,
  type: type.freeTextQuestion,
  image1: Fido,
  content1: 'President Lincoln had a dog named Fido (pictured). However, you won’t find any dogs sculptures at the memorial.',
  boldContent: 'What animal can you find?',
  hint: 'Look at the tripods / braziers that are on either side of the steps. There are multiple correct answers for this question.',

  answer: {
    answer: new RegExp("(lion|eagle)"),
    answerInfo: {
      image1: lionAndEagle,
      content1: "The answers is lion or eagle. You can see both lions and eagles in several places throughout the monument, such as the braziers (pictured), just above the Memorial columns, or inside next to the speeches",
    },
    image1: lionAndEagle,
    content1: "People have been creating sculptures of lions and eagles going far back into ancient history, with the lion representing courage and strength; and eagles representing freedom and majesty.",
  },
};
const lincolnTypoQ = {
  displayName: "Lincoln typo",
  location: lincoln,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'Checkout the quotes inside the temple, specifically the first panel to Lincoln\'s left (your right).',
  content2: 'You\'ll read that Lincoln had “high hope for the future”... ',
  boldContent: 'What did the memorial designers get wrong about this?',
  hint: 'There used to be a typo in one of the words of Lincoln\'s quote. It was fixed but is still visible if you look closely! What is the letter that was fixed?',
  answer: {
    answer: new RegExp("(^future$|euture|spell|f in|e in|typo|mistake|^f$|^e$|f is|e instead|the f|an e|an f|future|e is in|f/e|e/f|accident|error)"),
    answerInfo: {
      image1: lincolnTypo,
      //image1Caption: "",
      content1: 'The typo is that the F in Future was accidentally carved as an E! You can still see it if you look closely.',
    },
    // image1: "",
    content1: "All the lettering here was carved by hand, using chisels and hammers. As you can imagine, it took several years! ",
  },
};
const lincolnHands = {
  displayName: "Lincoln hands",
  location: lincoln,
  type: type.freeTextQuestion,
  image1: aslPoster,
  content1: 'The next answer lies in Abraham Lincoln’s body language. Assuming his right hand spells an "L", in American Sign Language (ASL),',
  boldContent: 'Putting the letters together, what do his hands represent?',
  hint: 'Lincoln’s hand spell "A" and "L" in American Sign Language. Put together, what is the significance of these two letters?',
  answer: {
    answer: new RegExp("(initial|lincoln|name)"),
    answerInfo: {
      image1: AL_Image,
      //image1Caption: "",
      content1: "The answer is Lincoln's initials! The L in the right hand is a little hard to see but is there if you look for it.",
    },
    //image1: ,
    content1: ' The sculptor, Daniel Chester French, gained an understanding of sign language characters when he sculpted a statue of John Hopkins Gallaudet, founder of Gallaudet University, school for the deaf and hard of hearing.',
    content2: 'Officially, however, the National Park Service says there is no sign language and that Lincoln\'s hand position is just random chance. Up to you to decide!'
  },
};
const numDoricColumns = {
  displayName: "Num Doric columns",
  location: lincoln,
  type: type.freeTextQuestion,
  image1: commonColumnTypes,
  content1: 'Everything at the Memorial is symbolic. For example, there are as many Doric columns lining the outside of the memorial as there were states in the union at the time of Lincoln\'s death.',
  boldContent: 'How many Doric columns are there in total at the memorial?',
  hint: "There are two additional Doric columns located at the entrance behind the colonnade. Don't double count corners.",
  answer: {
    answer: new RegExp("(^38$)"),
    answerInfo: {
      image1: LincolnColumns,
      //image1Caption: "",
      content1: "There are 38 columns. You don't count the ones inside the temple (they're Ionic). There are 36 directly on the outside and two additional columns in the second row framing the front entrance",
    },
    //image1: ,
    content1: 'The 36 columns outside the memorial are representative for the 36 states that were in the Union when Lincoln died. ',
  },
};
const mlkSpeechAtLincoln = {
  displayName: "MLK engraving",
  location: lincoln,
  type: type.multipleChoice,
  image1: null,
  content1: 'The Lincoln memorial doesn\'t just honor Lincoln. Among the steps, another is memorialized for a specific march. ',
  boldContent: 'What was that person marching for?',
  hint: 'From the top of the landing at the middle of the temple, start walking down. Watch your step!',
  specialContent: {
    initialCards: ['End slavery', 'Reparations', 'Affirmative Action', 'Jobs and Freedom'],
  },
  answer: {
    answer: "jobs and freedom",
    answerInfo: {
      image1: mlkEngraving,
      //image1Caption: "",
      content1: '18 steps from the top landing is an inscription that honors Dr. Martin Luther King and cites that King gave his speech during "the March on Washington for Jobs and Freedom."',
    },
    image1: mlkAtMarch,
    content1: 'This spot denotes where Dr. Martin Luther King (MLK) delivered his famous "I Have a Dream" speech in 1963',
    content2: 'In 2011 a memorial was erected specifically for MLK along the tidal basin. This course won\'t take you there but is included in our Capital Clues Tidal Basin course!',
  },
};
const arkansasDate = {
  displayName: "Arkansas roman numerals",
  location: lincoln,
  type: type.freeTextQuestion,
  image1: RomanNumerals,
  image1Caption: 'Roman numeral guide',
  content1: 'The next answer is higher than you may think.',
  boldContent: 'What year did Arkansas join the union?',
  hint: 'Get much closer to the reflecting pool. Take a look at the top of the Lincoln memorial and you will states listed and the year they joined the union. ',
  answer: {
    answer: new RegExp("(^1836$)"),
    answerInfo: {
      image1: ArkansasMichigan,
      //image1Caption: "",
      content1: "If you go down the steps and reach halfway to the reflecting pool, you'll see a second row of states at the very top of the memorial along with the date that they joined the Union in Roman numerals ",
      content2: "MDCCCXXXVI is Roman Numerals for 1836"
    },
    content1: "If you look at many of the dates, you'll notice that States were often admitted to the Union in pairs to balance the power between North and South. Within 7 months of Arkansas’s admission (a Southern, pro-slavery state), Michigan was admitted (a Northern free state).",
    content2: "The same type of power dynamics between political divisions may still be considered a factor today for territories seeking statehood, such as Puerto Rico.",

  },
};
const lincolnBathroom = {
  displayName: "Underneath Lincoln",
  location: lincoln,
  type: type.multipleChoice,
  image1: null,
  content1: "You've been inside the Lincoln memorial...",
  boldContent: 'What is underneath the Lincoln memorial?',
  hint: 'When facing the memorial, to the left of the steps there is a ramp that goes underneath. What is back there? ',
  specialContent: {
    initialCards: ['A Public Bathroom', 'Lincoln\'s Tomb', 'The original Emancipation Proclamation ', "The Tomb of Lincoln's wife and son"],
  },
  answer: {
    answer: 'A Public Bathroom',
    answerInfo: {
      image1: underneathLincoln,
      image1Caption: "",
      content1: 'It\'s the restrooms and a small Lincoln exhibit! ',
      content2: 'If you need to go, now may be a good time.'
    },
    image1: cavernBeneath,
    image1Caption: 'Source: nps.gov',
    content1: "Something that most don't know is that there is also a huge cavern beneath the memorial known as the undercroft. To support the marble structure up above, engineers built a massive cement support structure almost as tall as what we see above ground.",
    content2: 'The park service is considering expanding the exhibit area and including a viewing point into the undercroft.',
  },
};
const lincolnDone = {
  location: lincoln,
  type: type.locationDone,
  image1: lincoln.img,
  content1: "That is all the questions for the Lincoln memorial, nice work! This is a good time to use the restroom if you need it.",
};
const getToKorea = {
  location: korea,
  type: type.newLocation,
  image1: koreanPeninsula,
  content1: 'Your next destination is at a memorial for a war that, like the US Civil War, was fought between north and south. This war is technically not over and the North and South still have separate governments. ',
  content2: 'The war is also known as “the forgotten war”. It won’t be forgotten today!',
  captionContent: "Tap 'I'm here' when you can see the statues of some soldiers",
  answer: {
    image1: korea.img,
    content1: 'You made it to the Korean War Memorial! At this memorial and all the war memorials, please be respectful. You may see veterans or relatives who lost someone in the war.'
  },
};
const whichIsMedic = {
  displayName: "Where's the medic?",
  location: korea,
  type: type.freeTextQuestion,
  image1: koreanMemorialTriangle,
  image1Caption: 'Each of the soldiers you see maps to a number in the diagram.',
  content1: 'Soldiers wounded in the Korean war had a better chance of recovery than the soldier of any previous major war because of the introduction of the Mobile Army Surgical Hospital (MASH), and the MedEvac helicopter. ',
  //content2: 'Each of the soldiers you see maps to a number in the diagram above.',
  boldContent: 'Which soldier is the medic?',
  hint: 'The medic is not carrying a weapon or weapon part; they carry a box of medical equipment',
  answer: {
    answer: new RegExp("(^9$|^nine$|^14$|^fourteen$|^9 $)"),
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      content1: 'There are two medics. #9 and #14, identifiable because neither is carrying a weapon or weapon part but instead a box of medical supplies.',
    },
    image1: koreanMemorialTriangle,
    content1: koreanWarSoldierMapping,
    image2: null,
    content2: null,
  },
};
const powMiaFlagQ = {
  displayName: "POW MIA Not Forogtten",
  location: korea,
  type: type.freeTextQuestion,
  image1: findThisFlag,
  content1: 'This image is a symbol of remembrance. Find this symbol and you\'ll also see text that answers this content1:',
  content2: 'Note: Solving this question is dependent on the right weather. There are some days where this question is not solvable.',
  boldContent: 'What two groups are not forgotten?',
  hint: 'What is something tall at the memorial that is affected by wind?',
  answer: {
    answer: new RegExp("(^pow mia$|^mia pow$|pows and mias|pow and mia|pow & mia|pow/mia|powmia|p.o.w.|prisoners of war)"),
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      content1: 'The flag below the American flag is the POW/MIA flag and has this symbol',
    },
    image1: powMiaFlag,
    content1: 'The POW/MIA flag is flown with the American flag at all the war memorials on the national mall.\n' +
      '\n' +
      'It is a symbol to help remember the troops who never returned home -- those that went Missing in Action (MIA) or are taken Prisoners of War (POW). Even today, more than 82,000 Americans who fought in World War II, the Korean War, Vietnam, and other conflicts are still missing.',

  },
};

const freedom = {
  displayName: "What is not free",
  location: korea,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'The National Park service maintains the memorials and parks on the National Mall so that visitors can visit free of charge. ',
  boldContent: 'What, however, is not free?',
  hint: 'Read what it says on the wall that extends into the pool area',

  answer: {
    answer: new RegExp("(^freedom$)"),
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      content1: 'Freedom is not free. This quote is written on the wall that extends into the pool area, by the flag pole.',
    },
    //image1: null,
    content1: 'In US history, "Freedom is not free" is an idea that goes back to the American Revolution when the colonies fought for independence from the British.',
    content2: 'Thomas Jefferson wrote "The tree of liberty must be refreshed from time to time with the blood of patriots and tyrants."',
  },
};
const colombiansInKorea = {
  displayName: "Colombians in Korea",
  location: korea,
  type: type.freeTextQuestion,
  image1: unitedNationsFlag,
  content1: 'The US was not helping South Korea alone -- Would you have guessed a South American country was involved too? If you name this country, we’ll give you the next clue. ',
  boldContent: 'We ask for just one of the 22!',
  hint: 'The curb running along the northern side of the statues contains an alphabetical listing of the 22 nations that participated in the Korean War. \n',
  answer: {
    answer: new RegExp("(^columbia$|^colombia$)"),
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      content1: 'The curb running along the northern side of the statues contains an alphabetical listing of the 22 nations that participated in the Korean War. Columbia is the only South American country in the group',
    },
    content1: 'In the Korean War, seventeen nations provided combat units and five provided medical support as part of a United Nations (UN) military coalition. ',
    content2: 'A UN intervention was only possible because the Soviet Union (North Korea\'s ally) was boycotting the UN Security Council and thus was unable to use its veto power. They rejoined the Security Council shortly after the Korea resolutions were passed but by then the legal groundwork for a UN intervention had been laid and the Soviet Union was unable to stop it.',
    image3: unDeployments,
    image3Caption: 'Since the Korean War, the UN has sent military personnel for a number of other peace keeping missions (see above). ',
  },
};
const koreaDone = {
  location: korea,
  type: type.locationDone,
  image1: korea.img,
  content1: 'That is all the questions for the ' + korea.name + '. Nice work!',
};

const getToVietnam = {
  location: vietnam,
  type: type.newLocation,
  image1: null,
  content1: 'Your next destination is a memorial for yet another war fought between north and south. It was said it was “lost in the living room of America, not on the battlefield”',
  //hint: 'Just think about it',
  captionContent: "Tap 'I'm here' when you're next to the three soldiers statue.",
  answer: {
    image1: vietnam.img,
    content1: 'You made it! Out of respect, the next series of questions will not take you past the memorial\'s walls of names. However, we encourage you to walk through on your own.'
  },
};
const hatForProtection = {
  displayName: "Hat for protection",
  location: vietnam,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'Look for the three soldiers statue. This statue and the depicted soldiers represent the diversity of American soldiers in the Vietnam war -- they are hispanic, white, and black (in order from left to right)',
  boldContent: 'What’s something the soldier on the left is wearing for protection that is unique from the others?',
  hint: 'protection from the sun',
  answer: {
    answer: new RegExp("(hat|boonie)"),
    answerInfo: {
      image1: vietnamHat,
      //image1Caption: "",
      content1: 'The answer is a hat!',
    },
    //image1: '',
    content1: 'In Vietnam, American soldiers faced numerous environmental challenges that they were not used to, such as intense jungle heat, disease-carrying mosquitoes, and snakes. ',
    image2: SoliderSleepingInRain,
    image2Caption: "Soldier sleeping on top of a pill box to try and stay dry during Vietnam's monsoon season. Photo by Horst Faas",
    content2: 'During monsoon season, rains created muddy, waterlogged conditions, making it difficult for soldiers to move and maintain equipment. The constant wetness also led to health issues like trench foot.',
    content3: 'All these factors added additional stress and physical toll on the troops, already heightened by combat.'
  },
};
const numAnchors = {
  displayName: "Num of Anchors",
  location: vietnam,
  type: type.freeTextQuestion,
  image1: star,
  content1: 'Find the thing that looks like this symbol nearby.',
  boldContent: 'How many anchors surround it?',
  hint: 'Look for the US Flag and follow the pole down to the base!',
  answer: {
    answer: new RegExp("(^4$|^four$)"),
    answerInfo: {
      image1: anchorSolution,
      content1: 'The star is in the base of the Vietnam memorial\'s flagpole, surrounded by the seals of five military services. There are four anchors total. Two anchors in the Coast Guard seal, one in the Marine Corps seal, and one in the U.S. Navy seal.',
    },
    content1: personnelTable,
    content2: 'Some estimate that this was about 15% of the US male population aged 18-30 at the time.',
     },
};
const womenVietnam = {
  displayName: "Women In Vietnam",
  location: vietnam,
  type: type.multipleChoice,
  image1: null,
  content1: 'There is another statue, similar to the Three Soldiers, not too far away from here that is also part of the Vietnam War Memorial. ',
  boldContent: 'Who does this statue honor for their role in Vietnam?',
  hint: 'Look/Walk East to Discover the other statue.',
  specialContent: {
    initialCards: ['MEDIVAC Pilots', 'Women', 'The Tunnel Rats', 'CIA Operatives'],
  },
  answer: {
    answer: 'Women',
    answerInfo: {
      image1: womenStatueVietnam,
      //image1Caption: "",
      content1: "Walk East (away from the Lincoln), towards constitution Gardens and you will see the Vietnam Women's memorial",
    },
    //image1: '',
    content1: 'Women served in many ways in the Vietnam War. For example, women were nurses, physicians, air traffic controllers, communication specialists, and intelligence officers.',
    image2: womenInVietnam,
    content2: 'About 11,000 American women served in Vietnam. '
  },
};
const vietnamDone = {
  location: vietnam,
  type: type.locationDone,
  image1: vietnam.img,
  content1: 'That is all the questions for the ' + vietnam.name + '. Nice work!',
};

const getToConstitutionGardens = {
  location: gardens,
  type: type.newLocation,
  image1: null,
  content1: 'If you were going to be stuck on an island and could only bring 3 books, which books would you bring? ',
  content2: 'You won’t be stuck here but your next destination will be at the only island on the national mall!',
  captionContent: "Tap I'm here when you're at the bridge to get across",
  answer: {
    image1: gardens.img,
    content1: 'You made it!'
  },
};
const signersQuantity = {
  displayName: "How Many Signers",
  location: gardens,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'You probably know how many states there are, but...',
  boldContent: 'How many signers of the Declaration of Independence are there?',
  hint: 'Start walking across the bridge to the island. Watch where you step!\n',
  answer: {
    answer: new RegExp("(56|fifty six)"),
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      content1: 'Where the bridge starts, leading to the island, there is an inscription that says there were 56.',
    },
    image1: declarationOfIndependenceSigning,
    image1Caption: 'Declaration drafting committee presenting to the Continental Congress',
    content1: 'You may think the signing was a celebratory moment but it was the opposite. One of the Pennsylvania representatives said there was a “pensive and awful silence which pervaded the house when we were called up [...to sign] what was believed by many at that time to be our own death warrants.”',
    content2: "It was understood that if the colonies were unsuccessful, the British would likely execute leaders to suppress temptation of future rebellion."
  },
};
const tjProfession = {
  displayName: "TJ's profession",
  location: gardens,
  type: type.multipleChoice,
  image1: null,
  content1: (<Flex style={{flexDirection: 'column'}}>
    <Flex>Different people call me different things. I identify as a: </Flex>
    <ul>
      <li>Farmer</li>
      <li>Founder of a university</li>
      <li>Architect</li>
      <li>Inventor</li>
      <li>Slave Owner</li>
      <li>U.S. President</li>
      <li>Declaration writer</li>
    </ul>
  </Flex>),
  boldContent: 'But what is my reported profession?',
  hint: "This person was the third president, responsible for the Louisiana Purchase and writer of the declaration of independence.",
  specialContent: {
    initialCards: ['Planter', 'Lawyer', 'Politician', 'Merchant'],
  },
  answer: {
    answer: 'lawyer',
    answerInfo: {
      image1: tjStone,
      content1: "Thomas Jefferson's profession is noted as 'Lawyer' on the signer stones",
    },
    content1: "In 1760s Virginia, one did not need to go to law school to become a lawyer. After just two years of general studies at the College of William and Mary, Thomas Jefferson did an apprenticeship under a prominent lawyer named George Wythe before being admitted to the Bar.",
    content2: "Jefferson was a trial lawyer for eight years before moving onto his many other endeavours."
  },
};
const hancock = {
  displayName: "Run out of ink",
  location: gardens,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'Whenever we are signing papers, I am more likely to run out of ink before my colleagues. ',
  boldContent: 'Who am I?',
  hint: 'Some say size does not matter but I beg to differ when it comes to signatures! My profession is Merchant. Who am I?',
  answer: {
    answer: new RegExp("(hancock)"),
    answerInfo: {
      image1: hancockStone,
      content1: "A bigger signature requires more ink; If you look at the signature stones, Hancock's is the biggest."
      //image1: ,
      //image1Caption: "",
      //content1: '',
    },
    image1: declarationOfIndependence,
    image1Caption: "John Hancock's signature stands out as the largest on the Declaration of Independence",
    content2: 'It is joked that Hancock signed his name so boldly so that King George could read it without spectacles - a bold statement of defiance and confidence.'

  },
};
const ironMaster = {
  displayName: "Iron master",
  location: gardens,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'Nowadays, if I told someone my profession, they may think that I work at the gym. In reality, I make things! ',
  boldContent: 'Who am I?',
  hint: 'Look for someone who\'s profession involves "pumping iron" as Arnold Schwarzenegger calls it',
  answer: {
    answer: new RegExp("(taylor)"),
    answerInfo: {
      content1: 'The answer is George Taylor, whose profession is Ironmaster. ',
      //image1: ,
      //image1Caption: "",
      //content1: '',
    },
    image1: null,
    content2: 'George Taylor\'s iron furnace was the first to supply cannon shot to the continental army in the American Revolutionary War.'
  },
};
const constitutionGardensDone = {
  location: gardens,
  type: type.locationDone,
  image1: gardens.img,
  content1: 'That is all the questions for the ' + gardens.name + '. Nice work!',
  content2: "If you want to see the Declaration of Independence, Constitution, or Bill of Rights, you can do so at no cost at the National Archives, just down the road!"
};


const getToWWII = {
  displayName: "",
  location: wwII,
  type: type.newLocation,
  image1: null,
  content1: 'The following quote will guide you towards your next destination:',
  content2: '“Here in the presence of Washington and Lincoln, one the 18th century father and the other the 19th century preserver of our nation, we honor those 20th century Americans who took up the struggle during _____ ”',
  captionContent: "Tap I'm here when you are near a fountain",
  answer: {
    image1: wwII.img,
    content1: 'You made it!',
  },
};
const infamyDate = {
  displayName: "Date in Infamy",
  location: wwII,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'Make your way over to the Pacific part of the memorial (south side). ',
  boldContent: 'What is “a date which will live in infamy”?',
  hint: 'This is a quote etched in the granite on the pacific half of the memorial within the oval',
  answer: {
    answer: new RegExp("(december 7|12/7|dec 7)"),
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      content1: 'To the left of the American Samoa column marker, on the wall it is engraved "Pearl Harbor December 7th, a date which will live in infamy"',
    },
    image1: pearlHarborNews,
    image1Caption: 'Newspaper from Dec 8, 1941',
    content1: 'Japan surprise attack on Pearl Harbor\n' +
      '      officially drew the US into WWII. Strategically, Japan hoped to destroy the US\'s pacific fleet, which would have\n' +
      '      bought time for Japan to secure key oil and rubber interests in the Pacific and fortify defenses before the US could counter attack. ',

    image2: pearlHarborAttack,
    image2Caption: "Ships lined up side-by-side were easy targets for Japanese planes",
    content2: 'While the Japanese were able to wreck havoc on the ships in port, killing thousands of sailors, they weren\'t able to\n' +
'      sink any aircraft carriers. As luck would have it, all three carrier groups were at sea doing training exercises, hundreds of miles\n' +
'      away.',

    content3: 'Japan\'s allies, Germany and\n' +
      '      Italy (collectively "The Axis Powers") , declared war on the US out of solidarity on Dec 11th. At that point, Germany had\n' +
      '      already conquered most of Europe and was pushing the Soviet Union\'s lines closer and closer to Moscow.',
  },
};
const goldStarCount = {
  displayName: "# of Gold Stars",
  location: wwII,
  type: type.freeTextQuestion,
  image1: goldStar,
  content1: 'Look around and you\'ll find many of these gold stars. ',
  boldContent: 'How many are there?',
  hint: 'These are located on a wall facing the fountains - look for a information display to see how many there are',
  answer: {
    answer: new RegExp("(^4048$|^4,048$|^4049$|^4,049$)"),
    answerInfo: {
      image1: priceOfFreedom,
      content1: 'There are 4,048 stars. ',
      content2: 'Technically there are 4,049 stars if you count the metal star on the information display. But we went easy on you and accept either answer. '
    },
    content1: "The sheer number of gold stars, each symbolizing 100 American deaths, is a powerful reminder of the terrible cost and sacrifice of war. ",
    content2: WW2DeathsTable(),
  },
};
const sisterStatesQ = {
  displayName: "Sister states",
  location: wwII,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'I am a US State. Usually I’m not between these two sister states. ',
  boldContent: 'What state am I?',
  hint: 'I am one of the original 13 colonies - my pillar is between two states are very similar in name',
  answer: {
    answer: new RegExp("(^virginia$)"),
    answerInfo: {
      image1: virginiaPillar,
      content1: 'The answer is Virginia - the column is between North and South Carolina (the two sister states)',
    },
    //image1: virginiaPillar,
    //content1: 'The answer is Virginia - the column is between North and South Carolina',
  },
};
const kilroyWasHere = {
  displayName: "____ was here",
  location: wwII,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'When you walk around the memorial (on the outer path), you\'ll notice a golden fence enclosing a little bald headed man that was here before you. ',
  boldContent: 'Who was it?',
  hint: 'Near the Pennsylvania pillar, there is an officially sanctioned graffiti.\n',
  answer: {
    answer: new RegExp("(kilroy|killroy)"),
    answerInfo: {
      image1: kilroyLocation,
      //image1Caption: "",
      content1: 'By the Pennsylvania marker, there is a space between the two granite walls, enclosed by a gold-painted fence. The Kilroy graffiti is on the wall, saying "KILROY WAS HERE" ',
    },

    content1: '"Kilroy Was Here" was a cartoon that American GI\'s drew all over the\n' +
      '      place during WWII. It was originally started by James Kilroy, a ship inspector who would write "Kilroy Was Here"\n' +
      '      in different places on new ships. This was copy-catted all over as a joke and combined with a popular British\n' +
      '      military graffiti of the bald man. Together they went viral!',
    image2: kilroyImage,
    content2: 'Kilroy was known as "The first GI to arrive and the last to leave".\n' +
      '      Kilroy was drawn on bombs, enemy pillboxes, sides of trucks, and even in Joseph Stalin’s (leader of the Soviet Union) bathroom at\n' +
      '      the Potsdam Conference!',
  },
};
const ladyLibertyFoot = {
  displayName: "Lady Liberty's foot",
  location: wwII,
  type: type.multipleChoice,
  image1: null,
  content1: 'I am lady liberty - in my hands, I hold a broken sword. ',
  boldContent: 'But what does my right foot rest on?',
  hint: 'Look down at your feet and you may find the answer!\n',
  specialContent: {
    initialCards: ["a Tyrant's Body", 'a Boat', 'a Treasure Chest', 'a Helmet'],
  },
  answer: {
    answer: 'a Helmet',
    answerInfo: {
      image1: ladyLibertySeal,
      content1: 'On the ground in both the Atlantic and Pacific pavilions you can see lady liberty resting her foot on a helmet.',
    },
    image1: victoryMedal,
    content1: 'This image of Lady Liberty is on the WWII victory medal that was issued to all American service members that fought in the war',
    content2: 'That included the armed forces of the Philippines, which was an American colony during WW2. When the Japanese invaded, over 150,000 Filipinos fought against the Japanese. Here at the memorial, the Philippines is also recognized with its own pillar. '
  },
};
const ladyShoutingAtLovers = {
  displayName: "Lady Shouting",
  location: wwII,
  type: type.freeTextQuestion,
  image1: ladyShouting,
  content1: 'I am a lady shouting',
  boldContent: 'What is the person doing that I am shouting at?',
  hint: 'In the Washington monument direction, there are steps leading down towards the fountain. You can find the shouting lady on one of the plaques the line the walls along the steps',
  answer: {
    answer: new RegExp("(kiss|smooch|love|making out|snog|hug)"),
    answerInfo: {
      image1: coupleKissing,
      content1: 'They are kissing! This is on a plaque on the pacific side of the memorial on the wall to the right of the steps going towards the Washington Monument ',
      //image1: ,
      //image1Caption: "",
      //content1: '',
    },
    content1: 'In the aftermath of WW2, the US experienced a "baby boom". ',
    //content2: 'When the war ended, economists feared an economic recession, driven by less government spending on war material and returning soldiers transitioning back into normal jobs. However, the opposite happened and there was unprecedented economic growth and prosperity. ',
  },
};
const wwIIDone = {
  location: wwII,
  type: type.locationDone,
  image1: wwII.img,
  content1: 'That is all the questions for the ' + wwII.name + '. Nice work!',
};

const getToWashMon = {
  location: washMon,
  type: type.newLocation,
  image1: null,
  content1: 'Wherever you go on the national mall, you can always see me!',
  captionContent: "Tap 'I'm here' when there are no roads between you and the monument. ",
  answer: {
    image1: washMon.img,
    content1: 'You made it!',
  },
};
const getToWashMonMoriah = {
  location: washMon,
  type: type.newLocation,
  image1: null,
  content1: 'Wherever you go on the national mall, you can always see me!',
  captionContent: "Tap 'I'm here' when you have a clear view of the Washington Monument (you don't have to be close)",
  answer: {
    image1: washMon.img,
    content1: 'You made it!',
  },
};
const sundial = {
  displayName: "Sundial",
  location: washMon,
  type: type.freeTextQuestion,
  image1: sundialMap,
  content1: 'Imagine the Washington monument to be a sundial. At 10am, the monument casts a shadow on a small stone marker memorializing a sign-post or "pier" as it is officially called.',
  boldContent: 'What year was the pier re-erected?',
  hint: 'Look closely at the map and you\'ll discover that the Washington Monument is at the center of a clock! Where would the tip of the hour hand be at 10? X marks the spot!',
  answer: {
    answer: new RegExp("(1889)"),
    answerInfo: {
      image1: sundialMap,
      //image1Caption: "",
      content1: 'Where the X is on the sundial map (e.g. "10am") there a stone marker which says that it was re-erected in 1889',

      image2: jeffersonPier,
    },

    //content1: 'You may think "Pier" is related to a place to dock boats, especially when you consider that most of the area where we walked today used to be covered by the Potomac River or marshland. However, "Pier," in this context is used to mean marker, specifically to mark the spot that President Thomas Jefferson tried to make ' +
      //'the new Meridian line for the United States.',
    image2: primeMeridian,
    content2: 'Before the Meridian\n' +
      '        Conference in 1884, each country had their own defined Meridian Line for navigation\n' +
      '        (i.e. degrees east and west), which made maps very confusing. ',
    content3: "President Thomas Jefferson thought he would solve the problem by walking a short distance from the White House and putting down a wooden sign post declaring a new Meridian that the entire world could navigate by. However, he ultimately lost this battle when the world agreed to standardize navigation using Greenwich, England, as the Prime Meridian. This stone pillar before you is all that remains of Jefferson\'s dream",
  },
};
const overlayDCMapsWashMon = {
  displayName: "Overlay of DC Maps",
  location: washMon,
  type: type.informational,
  content1: <DCMapOverlap/>,
};

const shadesOfWashington = {
  displayName: "Shades of Washington",
  location: washMon,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'The outside of the Washington Monument is made of marble. However, the marble was sourced from multiple locations, which results in noticeably different colors of white at different heights of the monument. ',
  boldContent: 'How many locations did the builders get marble from? ',
  hint: null,
  answer: {
    answer: new RegExp("(2|two|3|three)"),
    answerInfo: {
      image1: wasMonumentShadesBreakdown,
      image1Caption: "Unfiltered image of the Washington Monument on a cloudy day",
      content1: "The difference is subtle and it can be hard to see if its really sunny but there are two shades of marble, with the first third of Washington Monument\'s being a lighter white than the top two thirds.",
      content2: 'Three is also an acceptable answer because if you look closely you can see a third shade lining the cornerstones at the base from repairs done in the 2010s due to earth quake damage.'
    },
    image1: WashMonUnderContsruction,
    image1Caption: 'The Washington monument remained half built like this for 22 years',
    content1: 'Vertically, there are two shades of stone because there was a huge pause in construction. By the time it resumed, stone from the first quarry had run out! To continue, builders used stone from a second quarry that was similar but not quite the same. ',
    content2: ' The first phase went from 1848 until 1854, when private funding for the project ran out. Ultimately, the US government took over the project for phase two, which ran from 1876 to 1884. The 22 year gap is in part due to the US civil war and its aftermath.',


  },
};
const numWashMonFaces = {
  displayName: "Number of faces",
  location: washMon,
  type: type.freeTextQuestion,
  image1: null,
  content1: null,
  boldContent: 'How many visible faces are there to the Washington monument?',
  hint: 'We aren\'t interested in human faces but instead geometric faces -- Faces are equivalent to sides. A pyramid has 4 visible faces (and one face that is not visible -- the bottom)',
  answer: {
    answer: new RegExp("(^8$|^eight$)"),
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      content1: 'There are 8 visible faces. There are 4 sides to the obelisk body and 4 to the pyramid at the top. The base of the obelisk is not visible so does not count',
      content2: '4 + 4 = 8'
    },
    image1: null,
    content1: 'This obelisk you see today is not how the monument was originally envisioned.',
    image2: OriginalDesignWashMon,
    image2Caption: 'The first design for the Washington Monument',
    content2: 'The original design in 1845 called for an obelisk with a nearly flat top and featuring a statue of Washington in a chariot. The bottom of the obelisk was to be surrounded by by a colonnade and 30 statues of Revolutionary War heroes.'

  },
};
const washingtonHeight = {
  displayName: "Washington height",
  location: washMon,
  type: type.freeTextQuestion,
  image1: null,
  content1: 'The flag poles that surround the monument are 25 feet tall.',
  boldContent: 'How tall (in feet) is the Washington Monument? Answers within 50ft are accepted',
  answer: {
    answer: new RegExp("(50[0-9]|5[1-9][0-9]|60[0-5])"), //https://3widgets.com/
    answerInfo: {
      //image1: ,
      //image1Caption: "",
      content1: 'If you stand further away from the Washington monument, you can estimate that it is about 20 to 24 flag poles tall.',
      content2: 'Since each flagpole is 25 ft tall, we multiply 20 x 25ft to determine that it is 500 ft tall for the lower range and multiply 24 x 25ft to determine 600 ft for the upper range of our estimation. Any answer between these two ranges is accepted.'
    },
    image1: null,
    content1: 'Standing at 555 feet, the Washington Monument was the tallest manmade structure in the world when it was finished in 1888! It\'s title, however, only lasted a year, when it was surpassed by the Eiffel Tower. ',
    content2: 'There are 50 flagpoles that surround the monument, one for each state',
  },
};
const washMonDone = {
  location: washMon,
  type: type.locationDone,
  image1: washMon.img,
  content1: 'That is all the questions for the ' + washMon.name + '. Nice work!',
};


export const washingtonToLincolnContent = {
  getToWashMon,
  shadesOfWashington,
  numWashMonFaces,
  sundial,
  overlayDCMapsWashMon,
  washingtonHeight,
  washMonDone,

  getToWWII,
  infamyDate,
  ladyShoutingAtLovers,
  goldStarCount,
  sisterStatesQ,
  kilroyWasHere,
  ladyLibertyFoot,
  wwIIDone,

  getToConstitutionGardens,
  signersQuantity,
  tjProfession,
  hancock,
  ironMaster,
  constitutionGardensDone,

  getToVietnam,
  hatForProtection,
  numAnchors,
  womenVietnam,
  vietnamDone,

  getToKorea,
  whichIsMedic,
  powMiaFlagQ,
  freedom,
  colombiansInKorea,
  koreaDone,

  getToLincoln,
  animalsAtLincoln,
  lincolnTypoQ,
  lincolnHands,
  numDoricColumns,
  mlkSpeechAtLincoln,
  arkansasDate,
  lincolnBathroom,
  lincolnDone,

};

export const lincolnToWashingtonContent = {
  getToLincoln,
  animalsAtLincoln,
  lincolnTypoQ,
  lincolnHands,
  numDoricColumns,
  mlkSpeechAtLincoln,
  arkansasDate,
  lincolnBathroom,
  lincolnDone,

  getToKorea,
  whichIsMedic,
  powMiaFlagQ,
  freedom,
  colombiansInKorea,
  koreaDone,

  getToVietnam,
  hatForProtection,
  numAnchors,
  womenVietnam,
  vietnamDone,

  getToConstitutionGardens,
  signersQuantity,
  tjProfession,
  hancock,
  ironMaster,
  constitutionGardensDone,

  tippingMidway,

  getToWWII,
  infamyDate,
  goldStarCount,
  sisterStatesQ,
  kilroyWasHere,
  ladyLibertyFoot,
  ladyShoutingAtLovers,
  wwIIDone,

  getToWashMon,
  sundial,
  overlayDCMapsWashMon,
  shadesOfWashington,
  numWashMonFaces,
  washingtonHeight,
  washMonDone,
};

export const moriahSchool = {
  getToLincoln,
  animalsAtLincoln,
  //lincolnTypoQ,
  lincolnHands,
  //numDoricColumns,
  mlkSpeechAtLincoln,
  //arkansasDate,
  lincolnBathroom,
  lincolnDone,

  getToKorea,
  whichIsMedic,
  //powMiaFlagQ,
  freedom,
  //colombiansInKorea,
  koreaDone,

  getToVietnam,
  hatForProtection,
  numAnchors,
  //womenVietnam,
  vietnamDone,

  // getToConstitutionGardens,
  // signersQuantity,
  // tjProfession,
  // hancock,
  // ironMaster,
  // constitutionGardensDone,

  //tippingMidway,

  // getToWWII,
  // infamyDate,
  // goldStarCount,
  // //sisterStatesQ,
  // kilroyWasHere,
  // ladyLibertyFoot,
  // //ladyShoutingAtLovers,
  // wwIIDone,

  getToWashMonMoriah,
  //sundial,
  //overlayDCMapsWashMon,
  shadesOfWashington,
  numWashMonFaces,
  //washingtonHeight,
  washMonDone,
};